// Posts reducer types
export const GET_POST = "GET_POST"
export const ADD_POST = "ADD_POST"
export const DELETE_POST = "DELETE_POST"
export const LIKE_POST = "LIKE_POST"
export const UNLIKE_POST = "UNLIKE_POST"
export const SUBMIT_COMMENT = "SUBMIT_COMMENT"
export const DELETE_COMMENT = "DELETE_COMMENT"
export const SET_POSTS = "SET_POSTS"
export const UPDATE_POST = "UPDATE_POST"
